import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// أنواع البيانات
export interface Admin {
  id: string;
  user_id: string;
  full_name: string;
  email: string;
  role: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface SiteSetting {
  id: string;
  setting_key: string;
  setting_value: any;
  description: string;
  updated_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface ChangeLog {
  id: string;
  admin_id: string | null;
  action_type: string;
  table_name: string;
  record_id: string | null;
  old_value: any;
  new_value: any;
  description: string;
  ip_address: string | null;
  user_agent: string | null;
  created_at: string;
}
